<template>
    <div class="border-t mx-4">
        <div class="pt-4 cursor-pointer text-a-black-080909 font-semiBold text-16">
            {{ lbl.serial.condition }}
        </div>
        <div class="pt-2.5 text-16 text-a-gray-666666 break-all">
            <div v-html="conditionText"></div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";

export default {
    name: "DetailAndCondition",
    props: {
        campaign: { type: Object, required: true },
        lbl: Object,
        blobConifg: Object,
    },
    data: function() {
        return {

            conditionText: null,
        };
    },
    created: function() {
        this.conditionText = Util.newLineToBr(this.blobConifg.query.locale == 1033 ? this.campaign.conditionEN : this.campaign.condition);
    },
    methods: {

    }
}
</script>
<style lang="scss" scoped>
    @import '../../../../style/base.scss';
    .font-semiBold {
        font-family: $ff-semi;
    }
</style>
